module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1092.045f1f64.png";